import { render } from "./Collapse.vue?vue&type=template&id=6063da1b&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=6063da1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6063da1b"],['__file',"src/common/components/Collapse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6063da1b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6063da1b', __exports__)) {
    api.reload('6063da1b', __exports__)
  }
  
  module.hot.accept("./Collapse.vue?vue&type=template&id=6063da1b&scoped=true", () => {
    api.rerender('6063da1b', render)
  })

}


export default __exports__